export default "__VITE_ASSET__BjwZp_UZ__"